(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitness-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('xeviom-hero-video')) {
  customElements.define('xeviom-hero-video', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.userPaused = false;
      this.userStarted = false;
      this.sourcesLoaded = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.userStarted = true;
          this.playVideo();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }, options);
      this.video.addEventListener('playing', () => {
        this.dataset.ready = 'true';
        this.updateButton();
      }, options);
      this.video.addEventListener('pause', () => this.updateButton(), options);
      this.video.addEventListener('error', () => {
        this.dataset.ready = 'false';
        this.updateButton();
      }, options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      this.reducedMotion.addEventListener('change', () => {
        this.userStarted = false;
        this.syncPlayback();
      }, options);
      if (navigator.connection) {
        navigator.connection.addEventListener('change', () => {
          this.userStarted = false;
          this.syncPlayback();
        }, options);
      }
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
        this.syncPlayback();
      }, { threshold: [0, 0.2, 1] });
      this.observer.observe(this);
      this.updateButton();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
      this.video?.pause();
      this.abortController = null;
    }
    syncPlayback() {
      const automaticAllowed = !this.reducedMotion.matches && !navigator.connection?.saveData;
      if (this.inView && !document.hidden && !this.userPaused && (automaticAllowed || this.userStarted)) {
        this.playVideo();
      } else {
        this.video.pause();
      }
    }
    async playVideo() {
      if (!this.sourcesLoaded) {
        this.video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
        });
        this.video.load();
        this.sourcesLoaded = true;
      } else if (this.video.error) {
        this.video.load();
      }
      if (!this.video.paused) return;
      try {
        await this.video.play();
      } catch {
        this.updateButton();
      }
    }
    updateButton() {
      const playing = !this.video.paused && !this.video.error;
      this.button.querySelector('span').textContent = playing ? this.dataset.pause : this.dataset.play;
      this.button.setAttribute('aria-label', playing ? this.dataset.pauseTitle : this.dataset.playTitle);
      this.button.querySelector('path').setAttribute('d', playing ? 'M5 4h3v12H5zM12 4h3v12h-3z' : 'M6 4l10 6-10 6z');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
